import Nullstack from 'nullstack';
export default function IconTrophy({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-trophy",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "4",
    x2: "17",
    y2: "4"
  }), "   ", Nullstack.element("path", {
    d: "M17 4v8a5 5 0 0 1 -10 0v-8"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "9",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "9",
    r: "2"
  }), " ");
}